import { RoleSlug } from '@askporter/grieg-types';
import { AllRoles, ManagerRoles, UserProfilePageRefs } from '../../types';

export const userProfilePagesVisibility: Record<UserProfilePageRefs, Array<RoleSlug>> = {
  global_preferences: [...ManagerRoles, RoleSlug.SVCUSRSPR, RoleSlug.SUPPSPR],
  login_security: [...ManagerRoles, RoleSlug.SUPPSPR, RoleSlug.SVCUSRSPR],
  notifications_preferences: [...ManagerRoles, RoleSlug.SUPPSPR, RoleSlug.SVCUSRSPR],
  personal_details: AllRoles,
};
